import { makeStyles } from '@material-ui/core/styles';
import { TextColors } from '@/utils/constants';

const darkTheme = {
  root: {
    '& $animatedSegment': {
      color: TextColors.light,
    },
  },
};

const lightTheme = {
  root: {
    '& $animatedSegment': {
      color: TextColors.dark,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
      position: 'relative',
      top: 0,
      left: 0,
      width: '100%',
      display: 'flex',
      height: '100%',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      width: '100%',

      [muiTheme.breakpoints.up('md')]: {
        height: '100%',
      },
    },
    headings: {
      position: 'relative',
    },
    heading: {
      ...muiTheme.typography.h2,
      display: 'flex',
      flexDirection: 'column',
      marginBottom: muiTheme.spacing(1),
      transition: 'font-size 500ms ease-in-out 500ms, font-weight 500ms ease-in-out 500ms',

      [muiTheme.breakpoints.up('md')]: {
        fontSize: '56px',
        lineHeight: 1,
        letterSpacing: '-0.31px',
        marginBottom: muiTheme.spacing(2),
      },

      '& p, h1, h2, h3, h4, h5, h6': {
        fontSize: 'inherit',
        fontWeight: 'inherit',
      },
    },
    subheading: {
      transition: 'height 500ms ease-in-out 500ms',

      '& p, h1, h2, h3, h4, h5, h6': {
        ...muiTheme.typography.h5,
      },
    },
    staticSegment: {},
    animatedSegment: {},
  }),
  { name: 'GenHeroHeadings' },
);

export default useStyles;
